import { render, staticRenderFns } from "./SettingsReception.vue?vue&type=template&id=4349eee2&scoped=true"
import script from "./SettingsReception.vue?vue&type=script&lang=js"
export * from "./SettingsReception.vue?vue&type=script&lang=js"
import style0 from "./SettingsReception.vue?vue&type=style&index=0&id=4349eee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4349eee2",
  null
  
)

export default component.exports